import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Step, XpStepsComponent } from './xp-steps.component';

@Component({
  selector: 'xp-step',
  template: `
    <div
      class="step"
      [ngClass]="{
        valid: stepItem.valid,
        active: stepItem.active,
        lock: stepItem.lock,
        error: stepItem.isError,
        loading: stepItem.isLoading
      }"
      *ngIf="!stepItem.disable"
    >
      <div class="step-header" (click)="toggle()">
        <xp-step-index [step]="stepItem"></xp-step-index>
        <div class="step-header-title">
          <span *ngIf="!stepItem.active">{{ stepItem.title }}</span>
          <span *ngIf="stepItem.active">{{ stepItem.activeTitle }}</span>
        </div>
        <div class="step-header-tags" *ngIf="!stepItem.active && stepItem.valid && stepItem.tags.length">
          <span class="step-header-tag" *ngFor="let tag of stepItem.tags" [innerHTML]="tag.name"></span>
        </div>
      </div>
      <div class="step-body xp-step-body" [ngClass]="{ expand: stepItem.active }">
        <div class="step-body-container" [ngClass]="{ wider: isWide }">
          <ng-content></ng-content>
        </div>
        <div class="step-buttons">
          <button type="button" class="btn btn-md btn-link" *ngIf="stepItem.index !== 0" (click)="back()">Back</button>
          <button
            type="button"
            class="btn btn-md btn-primary"
            *ngIf="!stepItem.isLast"
            [disabled]="!stepItem.valid"
            (click)="next()"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  `,
})
export class XpStepComponent implements AfterViewInit, OnDestroy, OnChanges {
  @Input() step: Step;
  @Input() isWide = false;
  @Output() activate = new EventEmitter();
  stepItem: Partial<Step> = {};
  stepIndex: number;
  changesSubscription: Subscription;

  constructor(private stepsComponent: XpStepsComponent) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.step.currentValue && !changes.step.firstChange) {
      this.stepsComponent.updateStepParams(changes.step.currentValue, this.stepIndex);
    }
  }

  ngAfterViewInit() {
    this.stepsComponent.addStep(this.step).subscribe((index) => {
      this.stepIndex = index;
      this.listenChanges(index);
    });
  }

  listenChanges(index: number) {
    this.changesSubscription = this.stepsComponent.listenChanges(index).subscribe((step) => {
      if (step.active && !this.stepItem.active) {
        this.activate.emit();
      }

      this.stepItem = step;
    });
  }

  toggle() {
    this.stepsComponent.setActiveFlag(this.stepIndex, !this.stepItem.active);
  }

  back() {
    this.stepsComponent.activatePreviousStep(this.stepIndex);
  }

  next() {
    this.stepsComponent.activateNextStep(this.stepIndex);
  }

  ngOnDestroy() {
    if (this.changesSubscription) {
      this.changesSubscription.unsubscribe();
    }
  }
}
